import { ratePct } from '@/lib/format'
import type { Scores } from '@/lib/types'

export function VisibilityRate({
  scores,
  totalQueries,
}: {
  scores: Partial<Scores>
  totalQueries: number
}) {
  const topRival = scores.shareOfVoice?.[1]
  return (
    <div className="h-full p-8 rounded-xl border border-border bg-card flex flex-col relative overflow-hidden">
      <div className="text-xs uppercase tracking-wider text-muted-foreground">
        Visibility Rate
      </div>
      <span className="text-6xl font-semibold text-primary tabular-nums mt-2">
        {ratePct(scores.rate)}%
      </span>
      <div className="mt-3 text-sm text-muted-foreground">
        Appeared in{' '}
        <span className="text-foreground">{scores.appearedIn ?? 0}</span> of{' '}
        <span className="text-foreground">{totalQueries}</span> queries
      </div>
      <div className="mt-6 h-2.5 overflow-hidden rounded-full bg-secondary">
        <div
          className="h-full bg-gradient-to-r from-primary to-accent transition-all duration-1000"
          style={{ width: `${ratePct(scores.rate)}%` }}
        />
      </div>
      {topRival && (
        <div className="mt-auto pt-4 border-t border-border text-sm">
          <span className="text-muted-foreground">Top rival: </span>
          <span className="font-medium">{topRival.name}</span>
          <span className="text-muted-foreground">
            {' '}
            · {topRival.percent.toFixed(0)}% SoV
          </span>
        </div>
      )}
    </div>
  )
}
